import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { PosCreditRequestRequirementDetailModule } from './../../shared/pos-credit-request-requirement-detail/pos-credit-request-requirement-detail.module';
import { PosTimeAgoModule } from './../../shared/pos-time-ago/pos-time-ago.module';
import { DocumentsStepModule } from './components/documents-step/documents-step.module';

import { CdkStepperModule } from '@angular/cdk/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { UiSwitchModule } from 'ngx-ui-switch';
import { RequiredAsteriskModule } from 'src/app/@core/directives/required-asterisk/required-asterisk.module';
import { PosCreditRequestCompanyBankingReferencesModalModule } from 'src/app/shared/pos-credit-request-company-banking-references-modal/pos-credit-request-company-banking-references-modal.module';
import { PosCreditRequestCompanyContactInformationModalModule } from 'src/app/shared/pos-credit-request-company-contact-information-modal/pos-credit-request-company-contact-information-modal.module';
import { PosOrderObservationsModule } from 'src/app/shared/pos-order-observations/pos-order-observations.module';
import { PosPersonReferenceModalModule } from 'src/app/shared/pos-person-reference-modal/pos-person-reference-modal.module';
import { PosStepperModule } from 'src/app/shared/pos-stepper/pos-stepper.module';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { BiometryModule } from '../biometry/biometry.module';
import * as fromComponents from './components';
import { CreditRequestRoutingModule } from './credit-request-routing.module';
import { CreditRequestComponent } from './credit-request.component';

@NgModule({
  declarations: [CreditRequestComponent, ...fromComponents.components],
  imports: [
    CommonModule,
    CreditRequestRoutingModule,
    PosStepperModule,
    CdkStepperModule,
    AccordionModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgxMaskModule,
    PosTableModule,
    PosCreditRequestCompanyContactInformationModalModule,
    PosCreditRequestCompanyBankingReferencesModalModule,
    TabsModule,
    ToastrModule.forRoot(),
    BsDatepickerModule,
    UiSwitchModule,
    PosPersonReferenceModalModule,
    RequiredAsteriskModule,
    PosTimeAgoModule,
    PosCreditRequestRequirementDetailModule,
    DocumentsStepModule,
    BiometryModule,
    PosOrderObservationsModule
  ],
  providers: [DatePipe],
  exports: [CreditRequestComponent, ...fromComponents.components],
})
export class CreditRequestModule { }
